import * as tslib_1 from "tslib";
import { observer } from 'mobx-react';
import { Button, ButtonType } from 'office-ui-fabric-react/lib/Button';
import { getRollupText } from 'owa-mail-focused-inbox-rollup-store';
import { updateWatermarkAndResetRollup } from 'owa-mail-focused-inbox-rollup-store';
import { onRollupClicked } from 'owa-mail-focused-inbox-rollup-store';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import ReadingPanePosition from 'owa-session-store/lib/store/schema/ReadingPanePosition';
import * as React from 'react';
import { getSelectedTableView, getFocusedFilterForTable } from 'owa-mail-list-store';
import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
var styles = require('./FocusedInboxRollup.scss');
var classNames = require('classnames/bind').bind(styles);
var FocusedInboxRollup = /** @class */ (function (_super) {
    tslib_1.__extends(FocusedInboxRollup, _super);
    function FocusedInboxRollup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderUnseenCount = function () {
            return (React.createElement("span", { className: styles.unseenCountBox }, _this.props.rollupState.unseenCountToDisplay));
        };
        _this.renderDismissButton = function () {
            return (React.createElement(Button, { buttonType: ButtonType.command, className: styles.dismissButton, onClick: _this.onDismiss, iconProps: {
                    iconName: "Cancel" /* Cancel */,
                    styles: {
                        root: isMailFeatureEnabled('tri-focused-sticky-rollup')
                            ? styles.dismissIcon
                            : null,
                    },
                } }));
        };
        _this.renderUniqueSenders = function () {
            return React.createElement("div", { className: styles.secondLineText }, _this.props.rollupState.uniqueSenders);
        };
        return _this;
    }
    FocusedInboxRollup.prototype.renderSingleLineRollup = function () {
        var isFocusedRollupExperiment = isMailFeatureEnabled('tri-focused-sticky-rollup');
        var outerContainerClass = classNames(styles.singleLineViewOuterContainer, isFocusedRollupExperiment && styles.isFocusedRollupExperiment);
        return (React.createElement("div", { className: outerContainerClass, onClick: onRollupClicked },
            React.createElement("div", { className: styles.firstColumnSingleLine },
                React.createElement("div", { className: styles.firstRowContainerSingleLine }, isMailFeatureEnabled('tri-focused-pivot')
                    ? null
                    : this.renderUnseenCount()),
                React.createElement("div", { className: styles.firstLineText }, getRollupText(this.props.rollupState.viewType))),
            this.renderUniqueSenders(),
            this.renderDismissButton()));
    };
    FocusedInboxRollup.prototype.renderThreeColumnRollup = function () {
        var isFocusedRollupExperiment = isMailFeatureEnabled('tri-focused-sticky-rollup');
        var outerContainerClass = classNames(styles.threeColumnViewOuterContainer, isFocusedRollupExperiment && styles.isFocusedRollupExperiment);
        return (React.createElement("div", { className: outerContainerClass },
            React.createElement("div", { className: styles.firstColumnThreeColumn }, isMailFeatureEnabled('tri-focused-pivot') ? null : (React.createElement("div", { className: styles.firstRowContainer }, this.renderUnseenCount()))),
            React.createElement("div", { className: styles.column, onClick: onRollupClicked },
                React.createElement("div", { className: styles.firstLineTextThreeColumn }, getRollupText(this.props.rollupState.viewType)),
                this.renderUniqueSenders()),
            this.renderDismissButton()));
    };
    FocusedInboxRollup.prototype.onDismiss = function (evt) {
        evt.stopPropagation();
        var focusedViewFilter = getFocusedFilterForTable(getSelectedTableView());
        updateWatermarkAndResetRollup(focusedViewFilter, 'ExitRollupButton');
    };
    FocusedInboxRollup.prototype.render = function () {
        var isReadingPanePositionRight = getUserConfiguration().UserOptions.GlobalReadingPanePositionReact ===
            ReadingPanePosition.Right;
        if (this.props.rollupState.uniqueSenders) {
            return isReadingPanePositionRight
                ? this.renderThreeColumnRollup()
                : this.renderSingleLineRollup();
        }
        else {
            return null;
        }
    };
    FocusedInboxRollup = tslib_1.__decorate([
        observer
    ], FocusedInboxRollup);
    return FocusedInboxRollup;
}(React.Component));
export default FocusedInboxRollup;
//# sourceMappingURL=FocusedInboxRollup.js.map